// src/index.js
import React from 'react';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import configureStore from './components/store/configureStore';
import { Provider } from 'react-redux';

import '../public/css/bootstrap-theme.css';
import '../public/css/fonts/font-awesome/css/font-awesome.css';
//import '../public/css/superfish.css';
import '../public/css/colors/superfish_Blue.css';
import '../public/css/revolution-slider/css/settings.css';
import '../public/css/revolution-slider/css/extralayers.css';
import '../public/css/prettyPhoto.css';
import '../public/css/revolution-slider/css/settings.css';

//import '../public/css/style.css';
import '../public/css/colors/style_Blue.css';
import '../public/css/global.css';


import '../public/css/theme-responsive.css';
import '../public/css/pricing-table-servico.css';
import '../public/css/invoice/invoice-style.css';

import '../public/css/switcher.css';
import '../public/css/spectrum.css';

//serviço.js
import 'react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';

import '../public/css/colors/blue.css';

var ReactGA = require('react-ga');

const store = configureStore();

ReactGA.initialize('UA-111512944-1');

function logPageView() {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
}

//import './index.css';
render(
    <Provider store={store}>
        <Router history={browserHistory} routes={routes} onUpdate={logPageView} />
    </Provider>,
    document.getElementById('root')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/